export const selectPayout = (state, id) => state.payouts.items[id] || {};

export const selectPayouts = state => Object.values(state.payouts.items) || [];

export const selectPayoutsLoading = state => state.payouts.isLoading;

export const selectPayoutPaginate = state => state.payouts.paginate || {};
